import register from '../../../../global/js/registry';
export default register('a-button', () => import(/* webpackMode: "lazy" */ './a-button.controller'));
